import { AcademicCycleDTO } from '../dto/AcademicCycleDTO';

/**
 * Academic Cycles Repository Interface
 */
export interface IAcademicCyclesRepository {
  getAll(workspaceId?: number): Promise<AcademicCycleDTO[]>;
  getActive(workspaceId?: number): Promise<AcademicCycleDTO[]>;
  getCurrent(workspaceId?: number): Promise<AcademicCycleDTO | null>;
}

/**
 * Get Academic Cycles Use Case
 *
 * Retrieves academic cycles, optionally filtered by workspace
 */
export class GetAcademicCyclesUseCase {
  constructor(private repository: IAcademicCyclesRepository) {}

  /**
   * Get all academic cycles for a workspace
   */
  async execute(workspaceId?: number): Promise<AcademicCycleDTO[]> {
    return await this.repository.getAll(workspaceId);
  }

  /**
   * Get only active academic cycles
   */
  async getActive(workspaceId?: number): Promise<AcademicCycleDTO[]> {
    return await this.repository.getActive(workspaceId);
  }

  /**
   * Get current academic cycle (active and within date range)
   */
  async getCurrent(workspaceId?: number): Promise<AcademicCycleDTO | null> {
    return await this.repository.getCurrent(workspaceId);
  }
}
